<template>
  <v-form ref="form">
    <v-row class="mt-3">
      <v-col cols="6">
          <v-text-field
              v-model="editableDriver.id"
              label="Driver Id"
              :disabled="true"
          ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
          :items="driverStatuses"
          v-model="editableDriver.status"
          label="Status"
          :disabled="true"
        >
          <template v-slot:selection="{ item }">
            {{ driverStatusToString(item) }}
          </template>
          <template v-slot:item="{ item }">
            {{ driverStatusToString(item) }}
          </template>
        </v-select>
      </v-col>
      <v-col cols="6">
          <v-text-field
              v-model="editableDriver.firstName"
              label="First Name"
          ></v-text-field>
      </v-col>
      <v-col cols="6">
          <v-text-field
              v-model="editableDriver.lastName"
              label="Last Name"
          ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-3" v-if="editable">
      <v-col cols="12">
        <v-btn
          class="mr-4"
          @click="save"
          :disabled="!dirty"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { DriverStatus, DriverStatusToString } from "../../../models/DriverStatus";
import moment from "moment";
import _ from "lodash";

export default {
    props: {
        driver: {
            type: Object,
            default: function() {
                return null;
            }
        },
        editable: Boolean
    },
    data() {
        const editableDriver = _.cloneDeep(this.driver);
        const editableIntegrationSources = [];
        for (var i = 0; i < 12; i++) {
            const flag = editableDriver.integrationSources & 1 << i;
            if (flag > 0) {
                editableIntegrationSources.push(flag);
            }
        }

        return {
            editableDriver,
            dirty: false,
            driverStatuses: Object.values(DriverStatus)
        };
    },
    watch: {
        driver(val) {
            this.editableDriver = (!val) ? {} : _.cloneDeep(val);
        },
        editableDriver:
    {
        handler() {
            this.dirty = true;
        },
        deep: true
    }
    },
    methods: {
        save: function() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.$emit("save", {
                firstName: this.editableDriver.firstName,
                lastName: this.editableDriver.lastName
            });
        },
        driverStatusToString(status) {
            return DriverStatusToString(status);
        },
        formatDateTime: function(datetime) {
            return moment(datetime).format("L LT");
        },
        close: function() {
            this.$emit("close");
        }
    }
};
</script>
